import { render, staticRenderFns } from "./CreateGroup.vue?vue&type=template&id=7485034a&scoped=true&"
import script from "./CreateGroup.vue?vue&type=script&lang=js&"
export * from "./CreateGroup.vue?vue&type=script&lang=js&"
import style0 from "./CreateGroup.vue?vue&type=style&index=0&id=7485034a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7485034a",
  null
  
)

component.options.__file = "CreateGroup.vue"
export default component.exports